import React, { Component } from "react";
import { leadType } from "../../app";
import commonContext, { AppContext } from "../context/common";

interface IProps {
    steps: Array<object>;
}
interface IState {
    steps: Array<object>;
}

class FormStep extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    base: any;
    activeFind = false;
    constructor(props: IProps) {
        super(props);
        this.state = {
            steps: props.steps,
        };
    }
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        this.base = (this.context as AppContext).base;
        return (
            <>
                <div className="w-full mb-4 mt-4 md:mb-8 md:mt-8">
                    <ul className="flex flex-wrap md:w-full lg:w-11/12 xl:w-4/5 mx-auto page-tracker justify-center">
                        {this.props.steps.map(
                            (
                                step: {
                                    title: string;
                                    active: boolean;
                                    failed?: boolean;
                                },
                                index: number
                            ) => {
                                let activeClass: string = "";
                                if (!this.activeFind) {
                                    if (step.active) {
                                        this.activeFind = true;
                                        activeClass = "active";
                                    } else {
                                        activeClass = "success";
                                    }
                                }
                                if (
                                    this.base === "dd-al" &&
                                    this.lead.typeOfCustomer === "ETB" &&
                                    step.title === "e-Mandate"
                                ) {
                                    return"";
                                }
                                return (
                                    <li
                                        key={index}
                                        className={
                                            "w-1/5 text-center openSans-Reg text-xs md:text-base lg:text-xl text-track flex flex-wrap flex-col justify-center items-center relative " +
                                            activeClass +
                                            (step.failed ? " failed" : "")
                                        }
                                    >
                                        <span className="rounded-full h-4 w-4 tracker-gray-circle track-circle relative"></span>
                                        {step.title}
                                    </li>
                                );
                            }
                        )}
                    </ul>
                </div>
                {(this.activeFind = false)}
            </>
        );
    }
}

export default FormStep;
